import { useState } from 'react';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import { CardMedia, Dialog, DialogTitle, IconButton } from '@mui/material';

import { IProducto } from '../../Interfaces/IProductos';
import { Tr4inerContainedButton } from '../../Utils/Button';

import CloseIcon from '@mui/icons-material/Close';

import './styles.css';


interface IDialog {
  isOpen: boolean;
  isCompras?: boolean;
  producto: IProducto;
  setIsOpen: (isOpen: boolean) => void;
  setIsCompras?: (isCompras: boolean) => void;
}

const CustomDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: '15px',
  },
}));

const DialogProductDescription: React.FC<IDialog> = (props) => {
  // for pdf
  // const [openPDF, setOpenPDF] = useState(false);
  // const [pdfLink, setPdfLink] = useState<string>('');

  const navigate = useNavigate();

  return (
    <>
      <CustomDialog
        fullWidth //Full width
        maxWidth="md"
        open={props.isOpen}
        onClose={() => {
          props.setIsOpen(false);
          props.setIsCompras(false);
        }}
      >
        <DialogTitle>
          <p className="title m-0">{props.producto.titulo}</p>
          <IconButton
            aria-label="close"
            onClick={() => {
              props.setIsOpen(false);
              props.setIsCompras(false);
            }}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <div className="container">
          <div className="row justify-center">
            <div className="col-12 col-md-5 flex items-center justify-center flex-col">
              <CardMedia
                component="img"
                src={props.producto.portada}
                sx={{
                  boxShadow: '0px 15px 15px -5px grey',
                  height: '300px',
                  objectFit: 'fit',
                  borderRadius: '15px',
                }}
              />
              {/* {props.isCompras && (
                <div
                  className="text-center my-4 title"
                  style={{ fontSize: '1.2rem', color: 'green', fontWeight: 'bold' }}
                >
                  Precio: ${props.producto.precio} Dolares
                </div>
              )} */}
            </div>
            <div className="col-12 col-md-6 text-center my-6">
              <div className="my-4">
                <div
                  className="my-4 title"
                  style={{ color: 'black', fontSize: '18px', fontWeight: 700 }}
                >
                  Descripción:{' '}
                </div>
                <div style={{ textAlign: 'justify' }} className="description">
                  {props.producto.descripcion}
                </div>
              </div>
            </div>
          </div>

          <div className="text-center my-3">
            {props.isCompras ? (
              <Tr4inerContainedButton
                onClick={() => window.open(props.producto.linkCompra)}
                style={{
                  padding: '8px 27px',
                  fontFamily: 'poppins',
                }}
                className="btnText"
              >
                Comprar
              </Tr4inerContainedButton>
            ) : (
              <a
                className="no-underline text-black"
                href={props.producto.linkPdf}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Tr4inerContainedButton
                  className="btnText"
                  // onClick={() => {
                  //   // setOpenPDF(true);
                  //   // setPdfLink(props.producto.linkPdf);

                  //   // establecer ruta para el botón de retroceso del PDF
                  //   if (localStorage.getItem('ruta')) {
                  //     localStorage.removeItem('ruta');
                  //     localStorage.setItem('ruta', '/');
                  //   } else {
                  //     localStorage.setItem('ruta', '/');
                  //   }

                  //   // establecer el link del PDF en el localStorage para el PDF
                  //   if (localStorage.getItem('linkPdf')) {
                  //     localStorage.removeItem('linkPdf');
                  //     localStorage.setItem('linkPdf', props.producto.linkPdf);
                  //     navigate('/pdf');
                  //   } else {
                  //     localStorage.setItem('linkPdf', props.producto.linkPdf);
                  //     navigate('/pdf');
                  //   }
                  // }}
                  style={{
                    padding: '8px 27px',
                    fontFamily: 'poppins',
                  }}
                >
                  Ver ebook
                </Tr4inerContainedButton>
              </a>
            )}
          </div>
        </div>
      </CustomDialog>
      {/* {openPDF && <PDFView zIndex={5500} link={props.producto.linkPdf} />} */}
      {/* {openPDF && (
        <PdfViewerComponent document={pdfLink} setOpenPdf={setOpenPDF} top={true} home={true} />
      )} */}
    </>
  );
};

export default DialogProductDescription;
